'use client'
import type React from 'react'
import { forwardRef } from 'react'
import { Flex } from '../flex'
import { Typography } from '../typography'

interface BulletProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Title */
  label: string
  /** Label or Button */
  labelOnly?: boolean
  children?: React.ReactNode
}

const cx = (...args: (string | false | null | undefined)[]) => args.filter(Boolean).join(' ')

/**
 * Bullet
 */
export const Bullet = forwardRef<HTMLDivElement, BulletProps>(
  (
    { label, labelOnly = true, children, className, onClick, onKeyDown, tabIndex, role, ...rest },
    ref
  ) => {
    return (
      <>
        <Flex align="center" gap="3">
          <div
            ref={ref}
            onClick={onClick}
            className={cx('size-2 rounded-full bg-[#FF6B35]', className)}
            {...rest}
          />
          <Typography>{label}</Typography>
        </Flex>
        {children}
      </>
    )
  }
)

Bullet.displayName = 'BulletLabel'
